<template>
  <ul class="page-subnav-tabs">
    <slot></slot>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="scss">
.page-subnav-tabs {
  position: absolute;
  bottom: 0px;
  right: 90px;
  font-size: 13px;
  margin: 0;
  padding: 0;

  .page-subnav-item {
    &:not(:last-child)::after {
      content: " >";
      font-style: normal;
      font-weight: bold;
    }
  }
}
</style>
